import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/CreateButton.css';
import { onActionKey } from '../../utils';

CreateButton.propTypes = {
    onAction: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    isCreateVisible: PropTypes.bool.isRequired,
};

function CreateButton(props) {
    const { onAction, children, isCreateVisible } = props;
    return (
        <div className="create-button" onClick={onAction} onKeyUp={onActionKey(onAction)} role="button" tabIndex={0}>
            <div className="create-button--arrow-mobile">
                <FontAwesomeIcon icon={`caret-${isCreateVisible ? 'down' : 'right'}`} />
            </div>
            <div className="create-button--title">{children}</div>
            <div className="create-button--arrow">
                <FontAwesomeIcon icon={`caret-${isCreateVisible ? 'down' : 'right'}`} />
            </div>
        </div>
    );
}

export default CreateButton;
